import axiosInstance from '@/services/axios'

const endPoint = {
	lookupBrandList: () => `brand/all`,
	lookupPopularBrandList: (offset, length) => `brand/popular?offset=${offset}&length=${length}`,
	lookupBrand: id => `brand?brandId=${id}`,
	// 입점 브랜드 이미지 목록 조회 API (baseURL에 /v1/mall/ 포함되어 있음)
	lookupBrandImages: () => `brand/images`,
}

const brandAPI = {
	lookupBrandList: () => axiosInstance.get(endPoint.lookupBrandList()),
	lookupPopularBrandList: (offset, length) => axiosInstance.get(endPoint.lookupPopularBrandList(offset, length)),
	lookupBrand: id => axiosInstance.get(endPoint.lookupBrand(id)),
	// 입점 브랜드 이미지 목록 조회
	lookupBrandImages: () => axiosInstance.get(endPoint.lookupBrandImages()),
}

export default brandAPI
